export default __webpack_public_path__ + "static/2010-1-782cbf49d686f2514b1e97c40236076f.jpg";